import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  TablePagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
} from "@mui/material";
import { useDispatch } from "react-redux";
import UpdatedOrdersDataTable from "./UpdatedOrdersDataTable";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

const UpdatedOrdersTable = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  // Filter states
  const [statusFilter, setStatusFilter] = useState("pending");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const getData = async () => {
    setIsLoading(true);
    const queryParams = [
      `status=${statusFilter}`,
      `per_page=${rowsPerPage}`,
      `page=${currentPage + 1}`,
    ].join("&");

    const { response } = await Helper.Get({
      url: `${api_Routes.Orders.ViewUpdated}?${queryParams}`,
      hasToken: true,
    });

    setData(response || []);
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, [statusFilter, currentPage, rowsPerPage, shouldRefresh]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return (
    <div className="pt-16">
      {/* Filter Section */}
      <div className="flex justify-between items-center flex-col gap-4 mt-5">
        <div className="w-full">
          <FormControl
            sx={{
              bgcolor: "white",
            }}
            className="w-full"
          >
            <InputLabel>Status</InputLabel>
            <Select
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value);
                setCurrentPage(0);
              }}
              label="Status"
            >
              <MenuItem value="pending">Pending</MenuItem>
              <MenuItem value="approved">Approved</MenuItem>
              <MenuItem value="rejected">Rejected</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      {/* Table and Pagination */}
      {isLoading ? (
        <LinearProgress sx={{ marginTop: 1 }} />
      ) : data?.data?.length > 0 ? (
        <>
          <div className="overflow-x-auto">
            <UpdatedOrdersDataTable
              data={data?.data}
              refreshData={() => setShouldRefresh(!shouldRefresh)}
            />
          </div>
          <div className=" flex gap-4 items-center justify-center">
            <TablePagination
              page={currentPage}
              onPageChange={handlePageChange}
              count={data.pagination.total}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25, 50]}
            />
            <button
              onClick={() =>
                setCurrentPage(
                  currentPage ===
                    Math.ceil(data.pagination.total / rowsPerPage) - 1
                    ? 0
                    : Math.ceil(data.pagination.total / rowsPerPage) - 1
                )
              }
            >
              {currentPage ===
              Math.ceil(data.pagination.total / rowsPerPage) - 1 ? (
                <div className="flex -ml-7">
                  <GoChevronRight />
                  <GoChevronRight className="-ml-3" />
                </div>
              ) : (
                <div className="flex">
                  <GoChevronLeft />
                  <GoChevronLeft className="-ml-3" />
                </div>
              )}
            </button>
          </div>
        </>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">No pending update requests</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default UpdatedOrdersTable;
